module.exports = __webpack_public_path__ + "static/hornsby-brett-03e6445d71157f5dc500bff2e32b81bc.jpg";